// extracted by mini-css-extract-plugin
module.exports = {"custom-wallet-button":"Account_custom-wallet-button__mi0x8","connectBtn":"Account_connectBtn__8Bnsc"};